import { connect } from 'react-redux';

import actionGetManagerReviews from 'store/manager-review/action';

import ManagerReviews from './ManagerReviews';

const mapStateToProps = (state) => ({
  isLoadingGetManagerReviews: state.ManagerReview.isLoadingGetManagerReviews,
  managerReviews: state.ManagerReview.managerReviews,
  totalManagerReviews: state.ManagerReview.totalManagerReviews,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetManagerReviews: (payload) => dispatch(actionGetManagerReviews(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerReviews);
